import { useBeta } from '../../context/BetaContext';
import { useTranslation } from '../../context/LanguageContext';

/**
 * Badge « Bêta » affiche a cote du logo pendant la periode beta.
 * Ne rend rien quand le mode Beta est inactif, ni pendant le chargement
 * de la configuration (evite un badge qui apparait puis disparait).
 *
 * Le style reprend celui du badge de BetaBanner
 * (px-2 py-0.5 text-xs font-bold uppercase rounded-full) adapte a un fond clair.
 */
const BetaBadge = ({ className = '' }) => {
    const { betaEnabled, betaLoading } = useBeta();
    const { t } = useTranslation();

    if (betaLoading || !betaEnabled) {
        return null;
    }

    return (
        <span
            data-testid="beta-badge"
            title={t.beta?.badgeLabel || 'Version bêta en cours'}
            aria-label={t.beta?.badgeLabel || 'Version bêta en cours'}
            className={`px-2 py-0.5 text-xs font-bold uppercase rounded-full bg-purple-100 text-cabaza-purple border border-purple-200 ${className}`}
        >
            Bêta
        </span>
    );
};

export default BetaBadge;
